import { Component, OnInit, OnDestroy } from '@angular/core'
import { Grange } from 'grange'
import { LoginInfo } from '@guillotinaweb/grange-core'
import { AppSettings } from 'app/theme/app.settings'

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit, OnDestroy {
  useToken = false
  error = ''
  isLogged: boolean

  constructor(private appSettings: AppSettings, public grange: Grange) {}

  ngOnInit() {
    setTimeout(() => {
      this.appSettings.settings.fixedHeader = false
      this.appSettings.settings.fixedSidenav = false
    })
    this.grange.core.auth.isAuthenticated.subscribe((auth) => (this.isLogged = auth.state))
  }

  onSubmit(data: LoginInfo | { token: string }) {
    this.error = ''
    if (!this.useToken) {
      const info = data as LoginInfo
      this.grange.core.auth.login(info.login, info.password).subscribe(
        (isLogged) => {
          if (isLogged) {
            this.grange.traverser.traverse('/@@welcome')
          }
        },
        (err) => {
          this.error = err.message
        }
      )
    } else if (!!data.token) {
      this.grange.core.auth.setAuthToken(data.token)
      this.grange.traverser.traverse('/@@welcome')
    }
  }

  ngOnDestroy() {
    setTimeout(() => {
      this.appSettings.settings.fixedHeader = true
      this.appSettings.settings.fixedSidenav = true
    })
  }
}
